/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Router from '@/router';
import { sortBy } from 'lodash/core';
import auth from '@/services/auth';
import { ADD_TOAST_MESSAGE } from '@/plugins/vuex-toastr/module';

// initial state
const state = {
  adapters: [],
};

// getters
const getters = {
  tabs: function (state) {
    return state.adapters.filter(({ type, channels }) => {
      return type === 'form' && (channels === 'all' || channels === 'builtin-chat' || !channels);
    });
  },
  icons: function (state) {
    return state.adapters.filter(({ type, channels }) => {
      return type === 'icon' && (channels === 'all' || channels === 'builtin-chat' || !channels);
    });
  },
};

// actions
const actions = {
  async fetchAdapters({ commit, dispatch }) {
    let baseRoot = `${window.location.protocol}//${window.location.host}`;
    const adaptersJSON = await fetch(`${baseRoot}/auth/adapters`);
    const adaptersRaw = await adaptersJSON.json();
    let adapters = [];

    for (let i = 0; i < adaptersRaw.length; i++) {
      if (adaptersRaw[i].showOnlyOnRedirect) {
        if (
          sessionStorage.getItem('return_to') &&
          sessionStorage.getItem('return_to').includes(adaptersRaw[i].showOnlyOnRedirect)
        ) {
          adapters.push(adaptersRaw[i]);
        }
      } else {
        adapters.push(adaptersRaw[i]);
      }
    }
    if (adapters.length === 1 && adapters[0].type === 'icon') {
      dispatch('signInByOpenWindow', adapters[0]);
    } else {
      commit('fetchAdapters', adapters);
    }
  },

  async signInByRequest({ dispatch }, params) {
    let response;

    try {
      const baseRoot = `${window.location.protocol}//${window.location.host}`;
      const authResponse = await fetch(`${baseRoot}${params.form.authPath}`, {
        method: 'post',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(params.data),
      });

      const authData = await authResponse.json();
      response = authData;

      if (authResponse.status !== 200) {
        throw { msg: "Can't sign in. Please check your login and password" };
      }

      // ---- for old login -----
      if (auth.checkCookie()) {
        auth.setLocalDataFromCookie();
      } else {
        const authData = authData;
        if (authData && authData.id && authData.userId) {
          auth.setLocalData(authData.id, authData.userId);
        } else {
          throw new Error({
            msg: 'Something wrong with your Cookies. Please check your security settings',
          });
        }
      }
      // ---- end for old login -----

      if (sessionStorage.getItem('return_to')) {
        const returnTo = sessionStorage.getItem('return_to');
        sessionStorage.removeItem('return_to');
        window.location = returnTo;
      } else {
        window.location = `${window.location.protocol}//${window.location.host}/builtinchat`;
      }
      Router.push('/');
    } catch (error) {
      if (params && params.form && params.form.template === 'local-guest') {
        dispatch('captcha/fetch', {}, { root: true });
      }
      console.log(error);

      let text = "Can't sign in. Please check your login and password";
      if (error.msg) text = error.msg;
      if (response.error) text = response.error.message;

      dispatch(ADD_TOAST_MESSAGE, { type: 'error', text }, { root: true });
      auth.clearCookieData();
    }
  },

  signInByOpenWindow({}, adapter) {
    let baseRoot = `${window.location.protocol}//${window.location.host}`;
    window.location = `${baseRoot}${adapter.authPath}`;
  },
};

// mutations
const mutations = {
  fetchAdapters(state, adapters) {
    state.adapters = sortBy(adapters, 'orderNum');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
